import "./src/styles/global.css";

export const onClientEntry = () => {
  const script = document.createElement("script");
  script.src = "https://js.tito.io/v2/with/inline/without/widget-css";
  script.async = true;
  document.head.appendChild(script);
};
